(() => {
  const root = window.Shopify?.routes?.root || '/';
  let continuing = false;
  let pending = null;

  async function prepareDeliveryDetails() {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    try {
      const response = await fetch(`${root}cart?section_id=hcx-next-day-cart-data`, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Unable to read delivery details');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = html.querySelector('[data-hcx-next-day-cart]');
      if (!data) throw new Error('Delivery details were not rendered');
      const items = JSON.parse(data.textContent).items.map(item => ({
        ...item,
        properties: Array.isArray(item.properties) ? Object.fromEntries(item.properties) : (item.properties || {})
      }));
      const mixed = items.some(item => !item.nextDay && item.requiresShipping);
      const delivery = mixed
        ? 'UK stock · Next working day delivery. This item arrives separately and before the standard-delivery items in your order.'
        : 'UK stock · Next working day delivery.';
      for (const item of items.filter(item => item.nextDay)) {
        if (item.properties?.Delivery === delivery) continue;
        const result = await fetch(`${root}cart/change.js`, {
          method: 'POST', credentials: 'same-origin', signal: controller.signal,
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: { ...(item.properties || {}), Delivery: delivery } })
        });
        if (!result.ok) throw new Error('Unable to save delivery details');
      }
    } finally {
      clearTimeout(timeout);
    }
  }

  function prepareAndContinue(event, control, resume) {
    if (continuing) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;
    control.setAttribute('aria-busy', 'true');
    pending = prepareDeliveryDetails()
      .catch(error => console.warn('Delivery message:', error.message))
      .finally(() => {
        control.removeAttribute('aria-busy');
        pending = null;
        continuing = true;
        try { resume(); } finally { continuing = false; }
      });
  }

  document.addEventListener('click', event => {
    const control = event.target.closest?.('[name="checkout"], a[href="/checkout"], a[href$="/checkout"]');
    if (!control || control.disabled || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    prepareAndContinue(event, control, () => control.click());
  }, true);

  document.addEventListener('submit', event => {
    const control = event.submitter;
    if (!control || control.name !== 'checkout') return;
    prepareAndContinue(event, control, () => event.target.requestSubmit(control));
  }, true);
})();
